/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Simple_Mulai_SubInputs */

const en_simple_mulai_sub = /** @type {(inputs: Simple_Mulai_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Describe the idea, Bystep writes the plan, then you choose who builds it.`)
};

const id_simple_mulai_sub = /** @type {(inputs: Simple_Mulai_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ceritakan idemu, Bystep menyusun rencananya, lalu pilih siapa yang membangunkan.`)
};

/**
* | output |
* | --- |
* | "Describe the idea, Bystep writes the plan, then you choose who builds it." |
*
* @param {Simple_Mulai_SubInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const simple_mulai_sub = /** @type {((inputs?: Simple_Mulai_SubInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Simple_Mulai_SubInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_simple_mulai_sub(inputs)
	return en_simple_mulai_sub(inputs)
});